'use client';

import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { Carousel } from '@mantine/carousel';
import { Box, Flex, Grid, Image, Modal } from '@mantine/core';
import classes from './Kyc.module.css';
import { KycCharacter } from './KycCharacter';
import { KycLeftSection } from './KycLeftSection';
import { KycMainControl } from './KycMainControl';
import { KycRegistration } from './KycRegistration';
import { KycRightSection } from './KycRightSection';
import { KycStepper } from './KycStepper';
import { KycWelcome } from './KycWelcome';
export const KycModal: React.FC = () => {
  const {
    successes,
    status
  } = useVerifyAction();
  const characterLocked = '/assets/kyc/character_2.png';
  const characterUnlocked = '/assets/kyc/character_armor.png';
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <Modal opened={openModal === MODAL.KYC} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.96)'
  }} size="100%" classNames={classes}>
      <KycStepper />

      <Flex direction={{
      base: 'column',
      sm: 'row'
    }} w="100%" h="100%" justify="center" pos="relative">
        <Grid w={{
        base: '100%',
        lg: '85%'
      }} mt={{
        sm: -60,
        lg: 0
      }}>
          <Grid.Col visibleFrom="sm" span={{
          sm: 4.6,
          lg: 3.25
        }} bg={{
          sm: 'var(--bg-200)',
          lg: 'transparent'
        }}>
            <KycLeftSection />
          </Grid.Col>

          <Grid.Col mt={-60} span={5.5} visibleFrom="lg">
            <Box pos="relative">
              <Image src={successes.has(STATUS.ID_VERIFICATION) ? characterUnlocked : characterLocked} alt="character" maw={689} mx="auto" />
              <KycMainControl />
            </Box>
          </Grid.Col>

          <Grid.Col span={{
          base: 12,
          sm: 7.4,
          lg: 3.25
        }} pos="relative" bg={{
          sm: 'var(--bg-100)',
          lg: 'transparent'
        }}>
            <Image visibleFrom="sm" hiddenFrom="lg" src="/assets/kyc/bg-tablet.png" alt="background" pos="absolute" inset={0} style={{
            zIndex: 0,
            objectFit: 'contain'
          }} />
            <KycRightSection />
          </Grid.Col>
        </Grid>

        {status === STATUS.REGISTRATION && <Carousel h="calc(100vh - 310px)" w="100%" slideSize="100%" withControls={false} withIndicators hiddenFrom="sm" classNames={{
        indicator: classes.indicator
      }}>
            <Carousel.Slide>
              <KycWelcome />
            </Carousel.Slide>
            <Carousel.Slide>
              <KycCharacter />
            </Carousel.Slide>
            <Carousel.Slide>
              <KycRegistration />
            </Carousel.Slide>
          </Carousel>}
      </Flex>
    </Modal>;
};